module.exports = __webpack_public_path__ + "img/subbg.06550d8c.jpg";